import React from 'react'

const Home = () => {
  return (
    <div><h1>Inicio</h1></div>
  )
}

export default Home